import type { FC } from 'react'
import Image from 'next/image'
import { getVipCategory, vipExpLevel } from '@g4g/utils/src/gameDataUtils'
import VipText from './VipText'

const VipExpLevelIcon: FC<{ vipExp: number; size: number }> = ({ vipExp, size }) => {
  const level = vipExpLevel(vipExp)
  const category = getVipCategory({ level })

  return (
    <div className="relative flex items-center justify-center">
      <Image
        src={`/shared-assets/img/resources/vip_category_icon_${category}.png`}
        width={size}
        height={size}
        alt={`Vip experience ${level}`}
      />
      <div className="absolute top-0 left-0 w-full h-full">
        <VipText vipCategory={category} className="flex items-center justify-center w-full h-full">
          {level}
        </VipText>
      </div>
    </div>
  )
}

export default VipExpLevelIcon
